export enum GoogleAnalyticsChartTypeEnum {
    COVERAGE_IMPACT_TREND = 'COVERAGE_IMPACT_TREND',
    REFERRAL_TREND = 'REFERRAL_TREND',
    TOP_SOCIAL_REFERRERS = 'TOP_SOCIAL_REFERRERS',
    TOP_REFERRAL_SOURCES = 'TOP_REFERRAL_SOURCES',
}
